import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";

import styles from "components/ReactTable/Components/Cells/Cells.module.css";

export default function Cells({ row }) {
    return row.cells.map((cell) => {
        // React warns when a key arrives through a spread, so take it out of the getter's props.
        const { key, ...cellProps } = cell.getCellProps();
        return (
            <td key={key} {...cellProps} className={styles.cell}>
                {cell.isGrouped ? (
                    // If it's a grouped cell, add an expander and row count
                    <>
                        <span {...row.getToggleRowExpandedProps()}>
                            {row.isExpanded ? (
                                <FontAwesomeIcon icon={faCaretUp} />
                            ) : (
                                <FontAwesomeIcon icon={faCaretDown} />
                            )}
                        </span>
                        &nbsp;&nbsp;
                        {cell.render("Cell")} &nbsp; ({row.subRows.length})
                    </>
                ) : cell.isAggregated ? (
                    // If the cell is aggregated, use the Aggregated
                    // renderer for cell
                    cell.render("Aggregated")
                ) : (
                    cell.render("Cell")
                )}
            </td>
        );
    });
}
